module.exports = __webpack_public_path__ + "assets/maritime-blue.451aa5fc.svg";